<!-- Delete Confirmation Alert in Georgian -->
<div class="mb-6 bg-red-50 border-l-4 border-red-500 p-4 rounded-md">
  <div class="flex items-start">
    <div class="flex-shrink-0">
      <!-- Warning Icon -->
      <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd" />
      </svg>
    </div>
    <div class="ml-3">
      <h3 class="text-sm font-medium text-red-800">გაფრთხილება: დაადასტურეთ წაშლა</h3>
      <div class="mt-1 text-sm text-red-700">
        <p>შემდეგი ჯავშ{{ bookings.length > 1 ? 'ნები' : 'ანი' }} სამუდამოდ წაიშლება თუ დაადასტურებთ ამ მოქმედებას. ეს
        ვერ იქნება გაუქმებული.</p>
      </div>
    </div>
  </div>
</div>

<!-- Booking Cards -->
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
  <!-- Card for each booking -->
  @for (booking of bookings; track booking) {
    <div
      class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <!-- Card header with branch info -->
      <div class="bg-primary-500 text-white px-4 py-2 font-medium">
        {{ booking.branch?.name }}
      </div>
      <!-- Card body with booking details -->
      <div class="p-4">
        <!-- Employee info -->
        <div class="flex items-center mb-3">
          <div class="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center mr-3">
            <span
            class="text-gray-600 font-bold">{{ booking.employee?.user?.firstname?.charAt(0) }}{{ booking.employee?.user?.lastname?.charAt(0) }}</span>
          </div>
          <div>
            <p class="font-medium">{{ booking.employee?.user?.fullName }}</p>
            <p class="text-xs text-gray-500">{{ booking.employee?.position?.name }}</p>
          </div>
        </div>
        <!-- Service info -->
        <div class="mb-3">
          <p class="text-sm text-gray-500">სერვისი</p>
          <p class="font-medium">{{ booking.service?.name }}</p>
          <p class="text-sm text-gray-500">{{ booking.service?.time }} წთ · {{ booking.price }} <i class="lari lari-c"></i></p>
        </div>
        <!-- Date and time -->
        <div class="flex justify-between items-center mt-4 pt-3 border-t border-gray-100">
          <div>
            <p class="text-sm text-gray-500">თარიღი</p>
            <p class="font-medium">{{ booking.bookingDate | date:'mediumDate' }}</p>
          </div>
          <div class="text-right">
            <p class="text-sm text-gray-500">დრო</p>
            <p class="font-medium">{{ booking.startTime }} - {{ booking.endTime }}</p>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Empty state -->
  @if (bookings.length === 0) {
    <div class="col-span-full bg-white rounded-lg shadow p-6 text-center text-gray-500">
      <svg class="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
      </svg>
      <p class="font-medium">ჯავშნები არ მოიძებნა</p>
      <p class="text-sm">ჯავშნები არ არის საჩვენებლად.</p>
    </div>
  }
</div>

<!-- Confirmation Buttons in Georgian -->
<div *nzModalFooter class="mt-6 flex justify-end space-x-3">
  <button type="button" class="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
    (click)="modalRef.close(false)">
    გაუქმება
  </button>
  <button type="button" class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
    nz-popconfirm
    nzPopconfirmTitle="{{ 'buttons.deletePop' | translate }}"
    nzPopconfirmPlacement="bottom"
    (nzOnConfirm)="modalRef.close(true)">
    წაშლის დადასტურება
  </button>
</div>
